import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Image from "../../../assets";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Color from "../../../utils/Color";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import PhoneIcon from "@material-ui/icons/Phone";
import AuthManager from "../../../utils/AuthManager";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: "100vh",
    overflow: "hidden",
    width: "100vw",
  },
  leftContainer: {
    background:
      "transparent linear-gradient(146deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box",
    padding: 20,
    height: "100%",
    width: "100%",
    overflow: "visible",
  },
  leftContainerNDC: {
    height: "100vh",
    overflow: "hidden",
    backgroundImage: `url(${Image.bgEtiqaNew})`,
    backgroundSize: "100% 100%", // Use "cover" for better scaling across all desktop sizes
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left center", // Prioritize left content visibility
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      backgroundSize: "100% 100%", // Fit image within container on larger screens
      //backgroundPosition: "left center", // Keep left focus
    },
  },
  imgStyle: {
    width: "100%",
    height: "100%",
  },
  childrenContainer: {
    width:'87%',
    marginBottom: 50,
    margin:"0 7%",
    [theme.breakpoints.down('sm')]: {
      width: '100%',          // or '96%' if you still want gutters
      margin: '0',            // centers automatically when width = 100 %
      marginBottom: 32,       // a bit less vertical space
    }
    // maxWidth:'490px'

  },
  childrenContainerFixWidth: {
    width:'87%',
    marginBottom: 50,
    margin:"0 7%",
    // width:"490px",
    [theme.breakpoints.down('sm')]: {
      width: '100%',          // or '96%' if you still want gutters
      margin: '0',            // centers automatically when width = 100 %
      marginBottom: 32,       // a bit less vertical space
    },
    maxWidth:'490px'

  },
  titleTextStyle: {
    ...getFontSize("xxxlarge"),
    ...getFontWeight("800"),
    color: "white",
    paddingLeft: 50,
    paddingRight: 50,
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      marginBottom: 100,
    },
    [theme.breakpoints.down("xs")]: {
      ...getFontSize("large"),
      marginBottom: 50,
    },
    marginTop: 20,
    marginBottom: 30,
  },
  bottomImageStyle: {
    width: 13,
    height: 13,
    marginRight: 10,
    [theme.breakpoints.down("xs")]: {
      color: Color.primaryTextColor,
    },
    color: Color.white,
  },
  bottomTextStyle: {
    fontSize: "13px",
    [theme.breakpoints.down("xs")]: {
      color: Color.primaryTextColor,
    },
    color: "#424143",
    fontFamily: "Muli",
  },
  scrollStyle: {
    "&::-webkit-scrollbar": { width: "10px" },
    "&::-webkit-scrollbar-track": { background: "#f1f2f8" },
    "&::-webkit-scrollbar-thumb": { background: "#E0E0E0" },
  },
}));

const CustomBoard = ({ maintenanceChild, children, height, width, directClient = false,isFixWidth=false }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

  const handleUserGuide = () => {
    window.open("https://www.etiqa.com.sg/about-tiqconnect/tiqconnect-user-guide/");
  };

  const handleContactUs = () => {
    window.open("https://www.etiqa.com.sg/contact/");
  };

  const handleLearnMore = () => {
    window.open("https://www.etiqa.com.sg/useful-information/online-security-tips/");
  };

  return (
    <Grid container className={classes.root}>
      {!matchesXS ? (
        <Grid item xs={12} sm={4} style={{ height: "100vh", overflow: "hidden" }}>
          <Grid container className={classes.leftContainerNDC}>
            <img
              src={Image.bgEtiqaNewH}
              style={{
                width: "34vw",
                height: "auto", // Maintain aspect ratio
                position: "absolute",
                top: "51%",
                right: "43%",
                objectFit: "contain", // Ensure full visibility
              }}
            />
            <div
              style={{
                width: "21.5%",
                height: "50px",
                position: "absolute",
                top: "85%",
                left: "70%",
                cursor: "pointer",
                [theme.breakpoints.down("md")]: {
                  top: "80%", // Adjust for smaller desktop screens
                  left: "60%",
                },
              }}
              onClick={() => handleContactUs()}
            ></div>
            <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
              {/* Commented-out content remains unchanged */}
            </Grid>
            <Grid item container xs={12} alignItems={"flex-end"} style={{ marginBottom: !matchesXS ? "3vh" : 0 }}>
              {/* Empty Grid */}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        false
      )}
      <Grid
        item
        xs={12}
        sm={8}
        style={{
          height: !matchesXS ? "100vh" : "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: 0,
          paddingBottom: !matchesXS ? "1.2rem" : "9rem",
          overflowY: matchesXS ? "auto" : "auto",
        }}
        className={classes.scrollStyle}
      >
        <div>{maintenanceChild}</div>
        <Grid
          container
          direction={"column"}
          alignItems={"center"}
          style={{
            ...(matchesXS
              ? { marginTop: 120 }
              : { flex: 1, justifyContent: "center", marginTop: 0 }),
          }}
        >
          <Grid item>
            <div className={isFixWidth ? classes.childrenContainerFixWidth : classes.childrenContainer}>{children}</div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomBoard;